
const routes = [
  {
    path: '/',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '', redirect: '/menu', component: () => import('pages/Menu.vue'), meta: { requiresAuth: true },
      },
      { path: 'login', component: () => import('pages/Login.vue') },
      { path: 'order', component: () => import('pages/Order.vue'), meta: { requiresAuth: true } },
      { path: 'cart', component: () => import('pages/Cart.vue'), meta: { requiresAuth: true } },
      { path: 'summary', component: () => import('pages/OrderSummary.vue'), meta: { requiresAuth: true } },
      { path: 'lastOrder', component: () => import('pages/LastOrder.vue'), meta: { requiresAuth: true } },
      { path: 'wolt-drive', component: () => import('pages/WoltDrive.vue'), meta: { requiresAuth: true } },
      { path: 'page/:codename', name: 'Page', component: () => import('pages/Page.vue') },
    ],
  },
  {
    path: '/menu',
    component: () => import('layouts/Default.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('pages/Menu.vue'),
      },
      {
        path: 'category/:id',
        component: () => import('pages/Category.vue'),
      },
      {
        path: 'lastOrder',
        component: () => import('pages/LastOrder.vue'),
      },
      {
        path: 'product/:id/:categoryId',
        component: () => import('pages/Product/Product.vue'),
      },
      {
        path: 'pizza/:id/:categoryId',
        component: () => import('pages/Product/Pizza.vue'),
      },
      {
        path: 'combo/:id/:categoryId',
        component: () => import('pages/Product/Combo.vue'),
      },
    ],
  },
  {
    path: '/settings',
    component: () => import('layouts/Default.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', component: () => import('pages/Settings.vue') },
      { path: 'lastOrder', component: () => import('pages/LastOrder.vue') },
      { path: 'userItems', component: () => import('pages/Settings/UserItems.vue') },
      { path: 'cards', component: () => import('pages/Settings/Cards.vue') },
      { path: 'information', component: () => import('pages/Settings/Information.vue') },
      { path: 'orders', component: () => import('pages/Settings/Orders.vue') },
    ],
  },
  {
    path: '/settings/addresses',
    component: () => import('layouts/Default.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', component: () => import('pages/Settings/Addresses.vue') },
      { path: 'create', component: () => import('pages/Settings/Addresses/Create.vue') },
      {
        name: 'EditAddress', path: 'edit', component: () => import('pages/Settings/Addresses/Create.vue'), props: true,
      },
    ],
  },
  {
    path: '/application',
    component: () => import('layouts/Default'),
    children: [
      { path: '', name: 'application', component: () => import('pages/Application.vue') },
    ],
  },
  {
    path: '/distancing',
    component: () => import('layouts/Default'),
    children: [
      { path: '', name: 'distancing', component: () => import('pages/Distancing.vue') },
    ],
  },
  {
    path: '/closed',
    component: () => import('layouts/Closed'),
    children: [
      { path: '', name: 'closed', component: () => import('pages/Closed.vue') },
    ],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error404.vue'),
});

export default routes;
